import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { LLMBlockWithMetadataSchema } from '@conversed/shared/src/central/types/blocks/LLMBlock';
import { z } from 'zod';
import { createRESTContract } from '../../index';

export const publicApiSettingsContract = createRESTContract({
  getPublicAPISettings: {
    method: 'GET',
    path: '/bot/public-api',
    permissions: [PERMISSIONS.PUBLIC_API_SETTINGS.PUBLIC_API_SETTINGS_EDIT],
    response: z.object({
      llmBlockId: z.string().optional(),
    }),
  },
  getPublicAPILLMBlocks: {
    method: 'GET',
    path: '/bot/public-api/llm-blocks',
    permissions: [PERMISSIONS.PUBLIC_API_SETTINGS.PUBLIC_API_SETTINGS_EDIT],
    response: z.array(LLMBlockWithMetadataSchema),
  },
  updatePublicAPISettings: {
    method: 'PUT',
    path: '/bot/public-api',
    permissions: [PERMISSIONS.PUBLIC_API_SETTINGS.PUBLIC_API_SETTINGS_EDIT],
    response: z.object({
      success: z.boolean(),
    }),
    body: z.object({
      llmBlockId: z.string(),
    }),
  },
});
